module.exports = __webpack_public_path__ + "img/53d23594142c97ef976235568b8d7468.0912b7be.jpg";